import { render, staticRenderFns } from "./expenseInfoModal.vue?vue&type=template&id=50471744&scoped=true&"
import script from "./expenseInfoModal.vue?vue&type=script&lang=js&"
export * from "./expenseInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./expenseInfoModal.vue?vue&type=style&index=0&id=50471744&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50471744",
  null
  
)

export default component.exports